import {Icon, IconButton, makeStyles, Menu, MenuItem} from "@material-ui/core";
import styled from "styled-components"
import React, {useContext, useState} from "react";
import {SelectionCriteriaContext} from "../SelectionCriteria/SelectionCriteriaContext";

const StyledContainer = styled.div`
    visibility: hidden;
`

const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const useStyles = makeStyles(({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}))
const SettingsMenu = ({path, index}) => {
    const [anchorEl, setAnchorEl] = useState(initialContextState)
    const {actions: {onChangeType}} = useContext(SelectionCriteriaContext)
    const classes = useStyles();

    function onClose() {
        setAnchorEl(initialContextState)
    }

    return (
        <>
            <StyledContainer id={"advancedFilter_actionMenu"}>
                <IconButton size={"small"} style={{}} onClick={e => setAnchorEl({
                    mouseX: e.clientX - 2,
                    mouseY: e.clientY - 4,
                })}>
                    <Icon style={{color: "#d0d0d0"}} fontSize={"small"}>settings</Icon>
                </IconButton>
            </StyledContainer>
            <Menu
                classes={{list: classes.contextPaper}}
                open={anchorEl.mouseY !== null}
                anchorReference={"anchorPosition"}
                anchorPosition={
                    anchorEl.mouseY !== null && anchorEl.mouseX !== null
                        ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                        : undefined
                }
                onClose={onClose}
            >
                <MenuItem
                    selected={true}
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        onChangeType('default', index)
                        onClose();
                    }}
                >
                    Default
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        onChangeType('sbFunction', index)
                        onClose();
                    }}
                >
                    Sb Function
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        onChangeType('string', index)
                        onClose();
                    }}
                >
                    String
                </MenuItem>
            </Menu>
        </>
    )
}

export default SettingsMenu;